module.exports = __webpack_public_path__ + "img/cam_1_on.d64a2034.png";